/**
 * External Dependencies
 */
import classnames from 'classnames'; //npm install classnames --save

/*

Read in a list of classes from local storage (originally from database / options table).

Create a ticklist from this to allow classes to be chosen for specified blocks.

Note -  Originally an array was used rather than a string for this but due to React not
		updating state if an array is pushed to or refactored (it's still an array!) a
		string type for the attribute was the only reliable way to do this.
*/

/**
 * WordPress Dependencies
 */
const { __ } = wp.i18n;
const { addFilter } = wp.hooks;
const { Fragment }	= wp.element;
const { InspectorControls }	= wp.blockEditor;
const { createHigherOrderComponent } = wp.compose;
const { PanelBody, CheckboxControl } = wp.components;

//restrict to specific block names
const allowedBlocks = [ 'core/columns', 'core/column', 'core/buttons' ];

/**
 * Add ability to select custom CSS classes.
 *
 * @param {Object} settings Settings for the block.
 *
 * @return {Object} settings Modified settings.
 */

function addAttributes( settings ) {

    //check if object exists for old Gutenberg version compatibility
    if( typeof settings.attributes !== 'undefined' && allowedBlocks.includes( settings.name ) ){

        settings.attributes = Object.assign( settings.attributes, {
            blocksolidClassesList: {
                type: 'string',
                default: ''
            }
        });

    }

    return settings;
}

/**
 * Add classes controls on Advanced Block Panel.
 *
 * @param {function} BlockEdit Block edit component.
 *
 * @return {function} BlockEdit Modified block edit component.
 */
const withAdvancedControls = createHigherOrderComponent( ( BlockEdit ) => {

    return ( props ) => {

        const {
            name,
            attributes,
            setAttributes,
            isSelected,
            clientId,
        } = props;

        const {
            blocksolidClassesList
        } = attributes;

        function checkChosenItems(val){
            if (val) {
                if (blocksolidClassesList.incudesl(val)) {
                    return false;
                }else{
                    return true;
                }
            } else {
                return false;
            }
        }

        function setChosenItems(val){

			var blocksolidClassesListTemp = blocksolidClassesList;

            if (val) {

				// NB. val has deliberately been sent with a trailing space

				//Filter out any orphaned classes should the master saved list have changed.
				var blocksolidClassesListTempArray = blocksolidClassesListTemp.split(" ");

				if (!(blocksolidClassesListTempArray === undefined || blocksolidClassesListTempArray.length == 0)) {

					var blocksolidClassesListFilter = blocksolidClassesListTempArray.map((item) => {
						if (locals.blocksolid_classes_available.indexOf(item) !== -1) {
							return item;
						}else{
							return '';
						}
					});
					var blocksolidClassesListTempFiltered = blocksolidClassesListFilter.filter((a) => a);
					blocksolidClassesListTemp = blocksolidClassesListTempFiltered.join(' ')+' ';

				}

                if (!(blocksolidClassesListTemp.includes(val))) {

					blocksolidClassesListTemp = blocksolidClassesListTemp+val;
					props.setAttributes({ blocksolidClassesList: blocksolidClassesListTemp });

					return true;

                 }else{

					let blocksolidClassesListTempWithValRemoved = blocksolidClassesListTemp.replace(val,"");
					props.setAttributes({ blocksolidClassesList: blocksolidClassesListTempWithValRemoved });

					return false;

                }

            }else{
				return false;
			}
        }

        return (

            <Fragment>
                <BlockEdit {...props} />
                { isSelected &&  allowedBlocks.includes( name ) &&
                    <InspectorControls>
                    <PanelBody
                    title={__('Style Classes', 'awp')}
                    initialOpen={ false }
                    >
                    {locals.blocksolid_classes_available.map((item) => (

                    <CheckboxControl
                        label={ item }
                        value={ item }
						key={ item+clientId }
                        checked={ !! (blocksolidClassesList.includes(item+" ")) }
                        onChange={ () => setChosenItems(item+" ") }
						__nextHasNoMarginBottom={ true }
                    />

                            ))}

                    </PanelBody>
                    </InspectorControls>
                }

            </Fragment>
        );
    };
}, 'withAdvancedControls');

/* Apply the adjustment in the editor too */
const withBlocksolidClasses = createHigherOrderComponent( ( BlockListBlock ) => {
    return ( props ) => {

	if ( allowedBlocks.includes( props.name )) {
        if(props.attributes.blocksolidClassesList.length < 1 || props.attributes.blocksolidClassesList == undefined){
	    	return <BlockListBlock {...props} />
		} else {
            return <BlockListBlock { ...props } className={classnames( props.className, props.attributes.blocksolidClassesList )} />;
       	}
	} else {
           	return <BlockListBlock {...props} />
    }

    };
}, 'withClientIdClassName' );

wp.hooks.addFilter( 'editor.BlockListBlock', 'pwd-blocks/with-client-id-class-name', withBlocksolidClasses )

function applyExtraClass( extraProps, blockType, attributes ) {

	const { blocksolidClassesList } = attributes;

	//check if attribute exists for old Gutenberg version compatibility
	//add class only when blocksolidClassesList = false
	//add allowedBlocks restriction
	if ( typeof blocksolidClassesList !== 'undefined' && blocksolidClassesList && allowedBlocks.includes( blockType.name ) ) {
		extraProps.className = classnames( extraProps.className, blocksolidClassesList );
	}

	return extraProps;
}

//add filters

addFilter(
    'blocks.registerBlockType',
    'pwd-blocks/custom-attributes',
    addAttributes
);

addFilter(
    'editor.BlockEdit',
    'pwd-blocks/custom-advanced-control',
    withAdvancedControls
);

addFilter(
	'blocks.getSaveContent.extraProps',
	'pwd-blocks/applyExtraClass',
	applyExtraClass
);